export var isMastheadLinkList = function (e) { return e.sys.contentType.sys.id === 'mastheadLinkList'; };
export var isMastheadGalleryMenu = function (e) { return e.sys.contentType.sys.id === 'mastheadGalleryMenu'; };
export var isMastheadCategoryMenu = function (e) { return e.sys.contentType.sys.id === 'mastheadCategoryMenu'; };
export var isMastheadLink = function (e) {
    return e.sys.contentType.sys.id === 'mastheadLink';
};
export var isMastheadLinkListItem = function (e) { return (e ? e.sys.contentType.sys.id === 'mastheadLinkListItem' : false); };
export var isLanguageSelectionItem = function (e) { return (e ? e.sys.contentType.sys.id === 'mastheadLanguageSelection' : false); };
